import React, { useState } from 'react';
import Reaptcha from 'reaptcha';
import { Form, Formik } from 'formik';

import { Button, Col, Row } from 'react-bootstrap';

import { SignUpSchema } from 'schema/sign-up.schema';

import PasswordRules from 'components/password-rules/password-rules.component';

import PasswordText from 'ui-kit/password-text';
import Text from 'ui-kit/text/text';

import './style.css';

const SignUpForm = ({ inviteCode, onSubmit, onSuccess }) => {
    const [captchaToken, setCaptchaToken] = useState('');
    const [captchaRef, setCaptchaRef] = useState(undefined);
    const [captchaVerified, setCaptchaVerified] = useState(false);

    const handleSubmit = (values) => {
        if (captchaVerified && onSubmit) {
            captchaRef.reset();

            onSubmit({ captchaToken, inviteCode, ...values, onSuccess });
        }
    };

    const onVerify = (verifyToken) => {
        setCaptchaVerified(true);
        setCaptchaToken(verifyToken);
    };

    return (
        <div className="sign-up-form">
            <Formik
                onSubmit={handleSubmit}
                validationSchema={SignUpSchema}
                initialValues={{
                    email: undefined,
                    password: undefined,
                    passwordConfirm: undefined
                }}
            >
                {(formik) => (
                    <Form onSubmit={formik.handleSubmit}>
                        <Row>
                            <Col>
                                <Text
                                    name="email"
                                    label="Email Address"
                                    onChange={formik.handleChange}
                                    value={formik.values?.email}
                                    touched={formik.touched.email}
                                    errors={formik.errors?.email}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <PasswordText
                                    name="password"
                                    label="Password"
                                    type="password"
                                    onChange={formik.handleChange}
                                    touched={formik.touched.password}
                                    value={formik.values?.password}
                                    errors={formik.errors?.password}
                                />
                                <PasswordRules
                                    errors={formik.errors?.password}
                                    touched={formik.touched.password}
                                    password={formik.values?.password}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <PasswordText
                                    name="passwordConfirm"
                                    label="Confirm Password"
                                    type="password"
                                    onChange={formik.handleChange}
                                    errors={
                                        formik.errors?.password || formik.errors?.passwordConfirm
                                            ? 'Confirmation password must match'
                                            : undefined
                                    }
                                    touched={formik.touched.passwordConfirm || formik.touched.password}
                                    value={formik.values?.passwordConfirm}
                                    showErrorsText
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Button
                                    variant="primary"
                                    type="submit"
                                    className="mb-3"
                                    disabled={captchaVerified ? '' : 'disabled'}
                                >
                                    Submit
                                </Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Reaptcha
                                    sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                                    onVerify={onVerify}
                                    ref={(e) => setCaptchaRef(e)}
                                />
                            </Col>
                        </Row>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default SignUpForm;
